import DOMPurify from 'dompurify'

const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024
const ALLOWED_FILE_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg']
const ALLOWED_FILE_EXTENSIONS = ['.pdf', '.png', '.jpg', '.jpeg']
const MAX_EVENT_QUERY_LENGTH = 120
const FILE_EXTENSION = /\.[^.]+$/

// The query is sent to the agent and shown back on Browse Assessments, so it is reduced to
// plain text before it leaves the page. DOMPurify's string output is serialised HTML, which
// would turn a typed & < > into entities, so the text is read from the sanitised DOM instead.
export function sanitizeQuery(query: string): string {
  return DOMPurify.sanitize(query, { ALLOWED_TAGS: [], ALLOWED_ATTR: [], RETURN_DOM: true }).textContent ?? ''
}

export function truncateQueryForEvent(query: string): string {
  if (query.length <= MAX_EVENT_QUERY_LENGTH) {
    return query
  }
  return `${query.slice(0, MAX_EVENT_QUERY_LENGTH)}...`
}

// A file needs both an allowed type and an allowed extension, since either alone is easy to
// spoof.
export function fileUploadErrorFor(file: File): string {
  if (file.size > MAX_FILE_SIZE_BYTES) {
    return 'File size exceeds 10MB. Please choose a smaller file.'
  }
  const extension = file.name.toLowerCase().match(FILE_EXTENSION)?.[0] ?? ''
  if (!ALLOWED_FILE_TYPES.includes(file.type) || !ALLOWED_FILE_EXTENSIONS.includes(extension)) {
    return 'Only PDF, PNG, and JPG files are allowed.'
  }
  return ''
}
